module.exports = __webpack_public_path__ + "static/img/customize-your-theme-and-questions.508a0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/customize-your-theme-and-questions.png
// module id = fnX2
// module chunks = 0